import { IAnalyticsEventRoleProperties, IAnalyticsRoleArgument } from './types';

export const getRoleEventProperties = (
  role: IAnalyticsRoleArgument,
): IAnalyticsEventRoleProperties => {
  return {
    object_type: 'role',
    object_name: role.name,
    object_id: role.id,
  };
};
